import { SpriteIcon } from "@shared/ui/SpriteIcon";
import { FindVinInfoProps } from "./types";
import classes from "./find-vin-info.module.scss";

export const FindVinInfo = ({ onClose }: FindVinInfoProps) => {
    const SAMPLE_VIN_IMAGE = "/img/history/vin-sample.webp";

    return (
        <div className={classes["find-vin"]}>
            <button className={classes["find-vin__close"]} onClick={onClose}>
                <SpriteIcon
                    className={classes["find-vin__close--icon"]}
                    section={"common"}
                    name={"close"}
                />
            </button>
            <img
                className={classes["find-vin__image"]}
                src={SAMPLE_VIN_IMAGE}
                alt="Пример СТС с VIN"
            />
            <div className={classes["find-vin__content"]}>
                <p className={classes["find-vin__title"]}>Как узнать номер</p>
                <p className={classes["find-vin__text"]}>
                    Номер автомобиля указан в Свидетельстве о регистрации (СТС) в графе
                    «Регистрационный знак», а VIN — в строке «Идентификационный номер».
                </p>
                <p className={classes["find-vin__text"]}>
                    Эти же данные дублируются в ПТС (Паспорте транспортного средства) и в полисе
                    ОСАГО
                </p>
            </div>
        </div>
    );
};